import { environment } from './../environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentsService } from './components.service';

@Injectable()
export class AuthGuard {
    loggedIn: boolean;
    private readonly baseUrl: string = environment.url;

    constructor(
        private router: Router,
        private service: ComponentsService,
    ) {}

    logIn(userData) {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append(
            'Cookie',
            'connect.sid=s%3AFnS79kQOoe2bF_01-xhf-XpxRY2NDwfq.dlg3ELuFqu%2FRuRo738PJTuWCmP1hj0tpJqrKipmXtd8',
        );

        let promise = new Promise((resolve, reject) => {
            fetch(`${this.baseUrl}/login/`, {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(userData),
                redirect: 'follow',
                credentials: 'include',
            })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        this.loggedIn = true;
                        console.log(data);
                        this.service.setServerTimeZoneOffset(
                            data.serverTimeZone,
                        );
                    } else {
                        this.loggedIn = false;
                    }
                    if (this.loggedIn == false) {
                        resolve('wrong username or password');
                    } else if (this.loggedIn) {
                        resolve(data);
                    }
                })
                .catch((error) => console.log('error', error));
        });
        return promise;
    }
    checkLogIn() {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        // myHeaders.append("Cookie", "connect.sid=s%3AFnS79kQOoe2bF_01-xhf-XpxRY2NDwfq.dlg3ELuFqu%2FRuRo738PJTuWCmP1hj0tpJqrKipmXtd8");

        let promise = new Promise((resolve, reject) => {
            fetch(`${this.baseUrl}/user/verifyUser`, {
                method: 'POST',
                headers: myHeaders,
                redirect: 'follow',
                credentials: 'include',
            })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    if (data.success) {
                        this.service.setUsersPerm(data.userInfo);
                        this.service.setServerTimeZoneOffset(
                            data.serverTimeZone,
                        );
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
        }).catch((error) => console.log('error', error));
        return promise;
    }

    logOut() {
        var myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append(
            'Cookie',
            'connect.sid=s%3AFnS79kQOoe2bF_01-xhf-XpxRY2NDwfq.dlg3ELuFqu%2FRuRo738PJTuWCmP1hj0tpJqrKipmXtd8',
        );

        fetch(`${this.baseUrl}/login/logout`, {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            credentials: 'include',
        })
            .then((data) => data.json())
            .then((data) => {
                this.router.navigate(['/']);
            })
            .catch((error) => console.log('error', error));
    }
}
